import { createSlice } from "@reduxjs/toolkit";

const configSlice = createSlice({
  name: "config",
  initialState: {
    data: null,
    fetchedAt: null,
  },
  reducers: {
    setConfig: (state, action) => {
      const payload = action.payload || {};
      state.data = { ...payload, __fetchedAt: Date.now() };
      state.fetchedAt = Date.now();
    },
    clearConfig: (state) => {
      state.data = null;
      state.fetchedAt = null;
    },
  },
});

export const { setConfig, clearConfig } = configSlice.actions;
export default configSlice.reducer;

